import { useEffect } from 'react'
import AOS from 'aos'

const useAOS = () => {
  /**
   * Issue animation not working.
   * https://github.com/michalsnik/aos/issues/110
   */
  useEffect(() => {
    AOS.init({
      once: true,
      delay: 50,
      duration: 500,
      easing: 'ease-in-out'
    })
    const handleWindowLoad = () => {
      AOS.refresh()
    }
    window.addEventListener('load', handleWindowLoad)
    return () => {
      window.removeEventListener('load', handleWindowLoad)
    }
  }, [])
}

export { useAOS }
